import { ChannelsScope } from './types';

export const channelMessagesInitial = Object.freeze({
  list: [],
  hasBefore: false,
  hasAfter: false,
  loading: false,
});

export const searchInitial = Object.freeze({
  channelID: null,
  query: '',
  results: [],
  loading: false,
});

export default Object.freeze({
  channels: [],
  channelsScope: ChannelsScope.UNREAD,
  messages: {},
  loading: false,
  sending: {},
  search: searchInitial,
});
